import API_PUBLIC_SERVICE, { SERVER_API, publicInstance } from './http';
import persistenceService from './persistence-service';
import { rutFormat } from '../libraries/formatters';

const PREFIX = 'users';
const path = PREFIX;
let activeUser = null;
const PERMISSIONS = {
  ADMIN: [
    'SUBSCRIPTOR_LIST',
    'ADD_SUBSCRIPTOR',
    'SUBSCRIPTOR_DETAIL',
    'MAINTAINER_LIST',
    'WARRANTY_LIST',
    'EDIT_WARRANTY',
    'DELETE_WARRANTY',
    'ADD_WARRANTY',
    'SERVICE_LIST',
    'EDIT_SERVICE',
    'DELETE_SERVICE',
    'ADD_SERVICE',
    'RISK_LIST',
    'EDIT_RISK',
    'DELETE_RISK',
    'ADD_RISK',
    'INSURANCE_LIST',
    'EDIT_INSURANCE',
    'DELETE_INSURANCE',
    'ADD_INSURANCE',
    'HEALTH_PLAN_LIST',
    'EDIT_HEALTH_PLAN',
    'DELETE_HEALTH_PLAN',
    'ADD_HEALTH_PLAN',
    'COMMUNE_LIST',
    'EDIT_COMMUNE',
    'DELETE_COMMUNE',
    'ADD_COMMUNE',
    'REGION_LIST',
    'EDIT_REGION',
    'DELETE_REGION',
    'ADD_REGION',
    'USER_LIST',
    'ADD_USER',
    'EDIT_USER',
    'DELETE_USER',
    'LOG_LIST'
  ],
  USER: ['SUBSCRIPTOR_LIST', 'ADD_SUBSCRIPTOR', 'SUBSCRIPTOR_DETAIL']
};

PERMISSIONS['Administrador'] = PERMISSIONS.ADMIN;
PERMISSIONS['Usuario'] = PERMISSIONS.USER;

const getPermissionsPerRol = name => {
  const permisions = PERMISSIONS[name];
  return permisions ? permisions : [];
};
const changePassword = async (id, json) => {
  try {
    const res = await publicInstance.put(`${SERVER_API}change-password`, json);
    let { data } = await res;
    return data;
  } catch (err) {
    const {
      response: { data }
    } = await err;

    throw data;
  }
};

const checkPassword = async password => {
  try {
    const user = persistenceService.getObject('user');
    const json = {
      username: user.username,
      password
    };
    await publicInstance.post(`${SERVER_API}login`, json);
  } catch (err) {
    throw err;
  }
};
const login = async json => {
  try {
    const res = await publicInstance.post(`${SERVER_API}login`, json);
    const { data } = await res;
    const { token, user } = data;
    user.token = token;
    persistenceService.save('token', token);
    persistenceService.save('user', user);
    activeUser = user;
    return data;
  } catch (err) {
    const {
      response: { data }
    } = await err;
    persistenceService.save('token', '');
    throw Object({
      ...data,
      errors: ['password']
    });
  }
};
const hasPermission = value => {
  const user = getCurrentUser();
  return user.permissions.includes(value);
};

const IsLogged = () => {
  const token = persistenceService.get('token');
  const currentUser = getCurrentUser();
  return Boolean(token && currentUser.enabled);
};

const hasRol = val => {
  const user = getCurrentUser();
  return user.role === val;
};
const getCurrentUser = () => {
  let user = activeUser;
  if (!activeUser) {
    user = persistenceService.getObject('user');
    activeUser = user;
  }

  if (!user) return {};
  const { role } = user;
  const permissions = getPermissionsPerRol(role);
  user.permissions = permissions;
  return user;
};

const logout = async () => {
  try {
    persistenceService.removeKey('user');
    persistenceService.removeKey('token');
    await publicInstance.get(`${SERVER_API}logout`);
  } catch (err) {
    const {
      response: { data }
    } = await err;
    throw Object({
      ...data,
      errors: ['logout']
    });
  }
};

const userPermission = {
  getCurrentUser,
  IsLogged,
  hasPermission,
  hasRol
};

const pagePath = '/users';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'username',
      key: 'username',
      disablePadding: false,
      numeric: false,
      label: 'Usuario'
    },
    {
      id: 'fullName',
      key: 'fullName',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: 'rut',
      key: 'rut',
      disablePadding: false,
      numeric: false,
      label: 'Rut',
      style: {
        width: '170px'
      },
      format: rutFormat
    },
    {
      id: 'rol',
      key: 'rol',
      disablePadding: false,
      numeric: false,
      label: 'Rol'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value =>
    value.map(elem => {
      return {
        ...elem,
        fullName: `${elem.name} ${elem.lastName}`,
        rol: elem.role
      };
    }),
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const UserService = {
  path,
  login,
  checkPassword,
  logout,
  changePassword,
  ...userPermission,
  ...API_PUBLIC_SERVICE,
  ...tableData
};

export default UserService;
